import { Subscription } from 'rxjs';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { PdvService } from '../../../services/pdv/pdv.service';

@Component({
    selector: 'product',
    templateUrl: 'product.component.html',
    styleUrls: ['product.component.scss'],
})
export class ProductComponent {
    @Input()
    product;
    loadAvatar = false;
    @Output()
    OnAdd:EventEmitter<boolean>=new EventEmitter<boolean>(); 
    @Output()   
    OnPersonalize:EventEmitter<boolean>=new EventEmitter<boolean>();  
    siteClose = false;
    subscriptions2: Subscription[] = [];
    constructor(
        private pdvService:PdvService
    ){
        
    }
    ngOnInit(){
        let sub=this.pdvService.pdv.subscribe(
            (data)=>{
                this.siteClose=data.closeSite;
            }
        )
        this.subscriptions2.push(sub);
    }

    addToBasket(){
        if(this.product.comp || this.product.maxNbrIngOptions>0 || this.product.hasSupp){
            this.OnPersonalize.emit(true);
        }else{
            this.OnAdd.emit(true);
        }
    }

    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }
}
